import EjesaSocialRate from './components/EjesaSocialRate';

const CUSTOM_FORMS = {
  EJESA_SOCIAL_RATE: 'form_259'
};

export const retrieveCustomForm = formCode => {
  switch (formCode) {
    case CUSTOM_FORMS.EJESA_SOCIAL_RATE:
      return EjesaSocialRate;
    default:
      return false;
  }
};
